module.exports = __webpack_public_path__ + "fonts/90fcc5a.otf";